export { default } from './Wrapper';



/** WEBPACK FOOTER **
 ** ./~/eslint-loader!./src/components/Page/PageComponents/Wrapper/index.js
 **/